import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    checkbox1,
    checkbox2,
    checkbox3,
    taxCalculationPeriod,
    releaseTime,
    firstTime,
    supplementaryForThe,
    isExport,
    releaseInVietNam,
    billExportDate,
    taxpayerName,
    taxId,
    contract,
    checkbox4,
    checkbox5,
    taxId2,
    taxId3,
    moneyType,
    fullName,
    certificate,
    signer,
    timeSign,
  },
} = checkout;

const validation = Yup.object().shape({
  [contract.name]: Yup.string().optional(),
  [checkbox1.name]: Yup.string().optional(),
  [checkbox2.name]: Yup.string().optional(),
  [checkbox3.name]: Yup.string().optional(),
  [checkbox4.name]: Yup.string().optional(),
  [checkbox5.name]: Yup.string().optional(),
  [isExport.name]: Yup.string().optional(),
  [releaseInVietNam.name]: Yup.string().optional(),
  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [moneyType.name]: Yup.string().required(moneyType.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [supplementaryForThe.name]: Yup.string()
    .matches(/^\d+$/, supplementaryForThe.invalidMsg)
    .required(supplementaryForThe.errorMsg),
  [taxCalculationPeriod.name]: Yup.number().required(taxCalculationPeriod.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
  [taxId2.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId2.invalidMsg)
    .required(taxId2.errorMsg),
  [taxId3.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId3.invalidMsg)
    .required(taxId3.errorMsg),
  [taxpayerName.name]: Yup.string().required(taxpayerName.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
  [releaseTime.name]: Yup.number().required(releaseTime.errorMsg),
  [billExportDate.name]: Yup.number().required(billExportDate.errorMsg),
});

export default validation;
